import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import Constants from "segments/desktop/grid/layouts/blog-cards-grid/constants";
const CARD_WIDTH = `${Constants.CARD_WIDTH}px`;
export const StyledBlogCardsGridComponent = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  height: 100%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .blog-card-item-component-wrapper {
    width: ${CARD_WIDTH};
    margin: 16px;
    flex-shrink: 0;
  }

  @media (max-width: 422px) {
    .blog-card-item-component-wrapper {
      width: 300px;
    }
  }

  @media (max-width: 332px) {
    .blog-card-item-component-wrapper {
      width: 280px;
    }
  }
`;
